import { render, staticRenderFns } from "./LanguageChanger.vue?vue&type=template&id=e8ba2fc8&scoped=true&"
import script from "./LanguageChanger.vue?vue&type=script&lang=js&"
export * from "./LanguageChanger.vue?vue&type=script&lang=js&"
import style0 from "./LanguageChanger.vue?vue&type=style&index=0&id=e8ba2fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ba2fc8",
  null
  
)

export default component.exports